<pane-card>
  <card-content ngProjectAs="card-main-content">
    <div class="overflow-y-auto h-100" style="max-height: 80vh;">

      @if(!notifications() || notifications().length === 0) {
        <div class="alert animate__animated animate__fadeIn animate__faster px-3 rounded-0 clip3 py-1 alert-warning d-flex align-items-center">
          <span class="material-icons font-9 me-2">warning</span>
          No Notifications
        </div>
      }
      @else {
        @for (notification of notifications(); track $index) {
        <div class="d-flex flex-column bg-white gap-1 mb-3 primary-text-100 px-3 py-1 rounded-2">
          @if(notification.isDismissable){
          <span class="text-muted text-end" role="button" (click)="deleteNotification(notification.id)" title="Dismiss notification">
            <svg-icon
                      fontSize="0.8rem"
                      key="close-icon"></svg-icon>
          </span>
          }
          <presenter [data]="notification.message"></presenter>
          <small class="text-muted text-end">{{ notification.createdDate | date:'dd MMM yyyy HH:mm' }}</small>
        </div>
        }
      }
    </div>
  </card-content>
</pane-card>